// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// i18n
import VueI18n from 'vue-i18n'
import i18nData from './lib/lang/index.js'

// axios
import axios from 'axios'
import VueAxios from 'vue-axios'

// GRAPHQL STUFF
import { provide } from '@vue/composition-api'
import { DefaultApolloClient } from '@vue/apollo-composable'
import ApolloClient from 'apollo-boost'

// BOOTSTRAP
// import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import { BootstrapVue, BootstrapVueIcons, ToastPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

// FONTAWESOME
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// vue-sweetalert2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import './assets/sb-admin/css/sb-admin.min.css'

// vue-multiselect
import 'vue-multiselect/dist/vue-multiselect.min.css'

// moment
import Moment from 'moment'

import VueAuthImage from 'vue-auth-image'

// dict tool
import Dict from './lib/dict.js'

import SystemSetting from './setting'

// ここでhostをチェックして切り替える
let hostname = window.location.protocol + '//' + window.location.host
// 本番: https://management.yamatenki.co.jp -> https://api.yamatenki.co.jp
// stage: https://stg-yamatenki-admin.alphaville.page/ -> https://stg-yamatenki-api.alphaville.page/
let apiname = hostname.replace('//management.', '//api.').replace('//mng.', '//api.').replace('//testmng.', '//testapi.')
// client apollo client
const apolloClient = new ApolloClient({
  uri: process.env.GRAPHQL_URL === '/graphql' ? apiname + process.env.GRAPHQL_URL : process.env.GRAPHQL_URL,
  request: (operation) => {
    console.log(operation)
    const token = store.state.auth.accessToken
    const session = localStorage.getItem(SystemSetting.SESSION_TOKEN_NAME)
    const conText = {
      headers: {}
    }
    if (token) {
      conText.headers.authorization = `bearer ${token}`
    }
    if (session) {
      conText.headers['X-Header-Session'] = session
    }
    operation.setContext(conText)
  }
})

// vue-auth-image
Vue.use(VueAuthImage)

Vue.config.productionTip = false

// moment
Moment.locale('ja')
Object.defineProperty(Vue.prototype, '$moment', { value: Moment })
// dict
Object.defineProperty(Vue.prototype, '$dict', { value: Dict })
// Setting
Object.defineProperty(Vue.prototype, '$setting', { value: SystemSetting })

// i18n
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja', // デフォルト言語設定
  fallbackLocale: 'ja', // 選択中の言語に対応する文字列が存在しない場合はこの言語の文字列を使用する
  messages: i18nData
})

// axios
Vue.use(VueAxios, axios)

// BOOTSTRAP
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// BOOTSTRAP ToastPlugin
Vue.use(ToastPlugin)

// FONTAWESOME
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// vue-sweetalert2
Vue.use(VueSweetalert2)

new Vue({
  // add the client to vue object
  setup () {
    provide(DefaultApolloClient, apolloClient)
  },
  store,
  router,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js